import * as Sentry from '@sentry/vue'

// Session diagnostics must not inherit URLs, breadcrumbs or user/session data.
export function reportSessionFailure(operation, reason) {
  Sentry.withScope(scope => {
    scope.clear()
    scope.setTag('session.operation', operation)
    scope.setTag('session.reason', reason)
    scope.setFingerprint(['portal-session', operation, reason])
    scope.addEventProcessor(event => {
      delete event.request
      delete event.user
      delete event.breadcrumbs
      delete event.extra
      delete event.contexts
      return event
    })
    Sentry.captureMessage('Portal session failure', 'error')
  })
}

export function sessionPersistenceFailure(operation, reason) {
  reportSessionFailure(operation, reason)
  return {
    sessionPersistenceFailed: true,
    data: { message: 'error_default_restart_transaction' }
  }
}
